import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './HeaderListingPagePersonalizable.css';
import React from 'react';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import getListing from '../../utils/getListing';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { get, canUseDOM } from '../../utils';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { removeQueryString } from '../Listing/index';
import { qsToObject } from '../../utils/querystring';
import { useHistory } from 'react-router-dom';
import { tokens } from '../atoms/gradientTheme';
var HeaderListingPagePersonalizable = function HeaderListingPagePersonalizable(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var pageName = get(fields, 'data.contextItem.headerTag.jss');
  var dotSite = get(sitecoreContext, 'site.name');
  var history = useHistory();
  if (dotSite === 'dotsite') {
    pageName = get(fields, 'data.datasource.pageName');
  }
  var pageTitle = get(fields, 'pageTitle') || get(fields, 'data.datasource.pageTitle');
  var pageTitleValue = get(fields, 'pageTitle.value') || get(fields, 'data.datasource.pageTitle.value');
  var pageIntro = get(fields, 'pageIntro') || get(fields, 'data.datasource.pageIntro');
  var Color = get(params, 'Color') || '';
  var GradientColor = get(params, 'Gradient Color') || '';
  var gradient = null;
  var start = '';
  var end = '';
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    heightGradien = _React$useState2[0],
    setHeightGradien = _React$useState2[1];
  var isMobile = canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false;
  // const headerTag = get(fields, 'pageIntro')

  if (Color && Color.length && GradientColor && GradientColor.length) {
    // @ts-ignore
    start = tokens[Color];
    // @ts-ignore
    end = tokens[GradientColor];
    gradient = "h1u2u3zr";
  }
  var _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    state = _React$useState4[0],
    setstate = _React$useState4[1];
  React.useEffect(function () {
    removeQueryString('type', history);
    if (canUseDOM) {
      if (Color && Color.length && GradientColor && GradientColor.length) {
        if (typeof window !== 'undefined') {
          document.querySelector('body').classList.add('colored');
          if (document.querySelector('.filter__wrapper')) {
            // @ts-ignore
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            setHeightGradien(document.querySelector('.filter__wrapper').offsetHeight);
          }
        }
      }
      // qsToObject
      var queryParams = qsToObject(history.location.search);
      var curatorID = '';
      if (queryParams['curators.curators.Id']) {
        curatorID = queryParams['curators.curators.Id'].toLowerCase();
        var itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Curator'], ["objectID:".concat(curatorID)]]
        };
        getListing(get(params, 'SearchIndex'), itemFilter).then(function (hits) {
          setstate(hits && hits.hits[0].title);
        });
      }
    }
  }, []);
  if (!fields) {
    console.warn('HeaderListingPagePersonalizable component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderListingPagePersonalizable component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    className: GradientColor && gradient && GradientColor.length ? '' : Color,
    rtl: rtl,
    style: {
      '--startColor': start,
      '--endColor': end
    }
  }, Color && Color.length && GradientColor && GradientColor.length ? /*#__PURE__*/React.createElement("span", {
    className: "".concat(gradient),
    style: {
      'height': isMobile ? '464px' : '700px'
    }
  }) : '', /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header header-generic--secondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageName && pageName.value && /*#__PURE__*/React.createElement("div", {
    className: "header__category"
  }, /*#__PURE__*/React.createElement(Text, {
    className: "c-category__text",
    tag: "span",
    field: pageName
  })), /*#__PURE__*/React.createElement("div", {
    className: "header__title"
  }, pageEditing && /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    field: pageTitle,
    className: "h2 c-title__text"
  }), !pageEditing && /*#__PURE__*/React.createElement("h1", {
    className: "h2 c-title__text"
  }, "".concat(pageTitleValue, " ").concat(state)))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, pageIntro && /*#__PURE__*/React.createElement(Text, {
    className: "p header__content",
    tag: "p",
    field: pageIntro
  })))))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className,
    _ref2$style = _ref2.style,
    style = _ref2$style === void 0 ? {} : _ref2$style;
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className, " ").concat(headerImageStyle)
  }, children);
};
export var commonStyles = "cs7g6kx";
export var ltrStyles = "l1mw24d3";
export var rtlStyles = "rkwwdan";
export default HeaderListingPagePersonalizable;